import React, { forwardRef } from "react";
import { DivBasedComponentProps } from "@reusables/BaseTableV2/types";
import { cn } from "@helpers/utils";

const Body = forwardRef<HTMLDivElement, DivBasedComponentProps>(function({ children, ...props }, ref) {
    return (
        <div
            {...props}
            className={cn(
                "flex flex-col text-[#3C3769] text-sm",
                props.className
            )}
            ref={ref}
        >
            {children}
        </div>
    );
});

export default Body;